export default __webpack_public_path__ + "static/media/18.284efa11.jpg";